/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';

import template from './ax-review-list-page.component.html';
import {AdminListColumn, AdminResourceListPageBase} from '../common/controller/admin-resource-list-page-base';
import {deviceTargetSubDevices, previewParams} from './review-list-page-utils';
import {createReviewApproveHandler} from './review-commons';
import {ReviewRejectModalService} from './review-reject-modal.service';
import {LineItemResource} from '../../components/api/resources/resource/line-item.resource';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-ax-review-list-page',
  template
})
export class AxReviewListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.adv.line-items.line-item';
  readonly lineItemItemStateName = 'app.adv.line-items.line-item';
  readonly productItemStateName = 'app.adm.products.product';
  readonly orderItemStateName = 'app.adv.orders.order';
  readonly layoutItemStateName = 'app.adm.layouts.layout';
  readonly tierItemStateName = 'app.adm.tiers.tier';
  readonly userItemStateName = 'app.adm.users.user';

  readonly columns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'objective'},
    {param: 'updateTime', label: 'dates'},
    {param: '', label: 'creativeInfo', sortable: false},
    {param: '', label: 'preview', sortable: false}
  ];

  readonly deviceTargetSubDevices = deviceTargetSubDevices;
  readonly previewParams = previewParams;

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any,
    @Inject(LineItemResource) private readonly LineItem: any,
    private readonly reviewRejectModalService: ReviewRejectModalService
  ) {
    super(LocalNetworkProfile);
  }

  protected afterListInit(): void {
    if (!this.list) {
      return;
    }
    if (!this.list.reject) {
      this.list.reject = this.reviewRejectModalService.createRejectHandler(this.list);
    }
    if (!this.list.approve) {
      this.list.approve = createReviewApproveHandler(this.list, this.LineItem);
    }
  }
}
